import util from '@bmp-vue/core/api/util'
const controller = 'Portal'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetIdVisualPortal: function (codigo) {
    return util.Axios.Get(controller + '/GetIdVisualPortal', codigo)
  },
  GetIdVisualPortalEnabled: function (codigo) {
    return util.Axios.Get(controller + '/GetIdVisualPortalEnabled', codigo)
  },
  PutCustomJSON: function (id, dto) {
    return util.Axios.Put(controller + '/PutCustomJSON', id, dto)
  }
})
